import { render } from "./settingsprofilecompany.vue?vue&type=template&id=db45f6de&scoped=true"
import script from "./settingsprofilecompany.vue?vue&type=script&lang=js"
export * from "./settingsprofilecompany.vue?vue&type=script&lang=js"

import "./settingsprofilecompany.vue?vue&type=style&index=0&id=db45f6de&scoped=true&lang=css"

import exportComponent from "/Users/zonegoh/Documents/GitHub/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db45f6de"]])

export default __exports__